import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'ngx-login-client';

// tslint:disable-next-line:use-pipe-transform-interface

export class AlmUserName implements PipeTransform {
  transform(userObj: User | null = null, notFound: string = 'User not found'): string {
    if (typeof(userObj) === 'undefined' || userObj === null) {
      return notFound;
    }
    if (userObj.hasOwnProperty('attributes')) {
      if (userObj.attributes.hasOwnProperty('fullName')) {
        if (userObj.attributes.fullName && userObj.attributes.fullName.trim()) {
          return userObj.attributes.fullName;
        }
      }
    }
    return '';
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'almUserName', pure: true }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
